var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.transcript.evasion?.outlierPredictive)?_c('span',{staticClass:"outlier"},[_vm._v("Predictive Outlier")]):(_vm.transcript.evasion?.outlier)?_c('span',{staticClass:"outlier"},[_vm._v("Outlier")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }